module.exports = __webpack_public_path__ + "static/img/pipeline-junction-cross_256.641e91c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pipeline-junction-cross_256.png
// module id = jLcl
// module chunks = 0